import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="26"
        viewBox="0 0 21 26"
    >
        <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square">
            <path d="M.51 24.79h17.742M5.349 20.758H.51V15.92L15.026 1.403l4.839 4.839z" />
        </g>
    </svg>
);

/**
 * Toolbar button for freehand draw selection mode.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered draw button.
 */
const DrawButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default DrawButton;
